import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'
import 'swiper/css'

const init = async (parent) => {
    return new Promise((resolve) => {
        const swiper = parent.querySelector('.swiper-container')
        const nextEl = parent.querySelector('.swiper-next')
        const prevEl = parent.querySelector('.swiper-prev')

        const swiperInstance = new Swiper(swiper, {
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 32,
            modules: [Navigation],
            watchOverflow: true,
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                1024: {
                    slidesPerView: 3
                }
            },
            navigation: {
                nextEl,
                prevEl
            },
            on: {
                init: function () {
                    const nav = parent.querySelector('.js-nav')
                    if (nav) {
                        nav.classList.remove('opacity-0')
                    }
                    swiper.classList.remove('opacity-0')
                }
            }
        })
        return resolve('Services done')
    })
}

export { init }
